// actions/invitation.js

import { toast } from 'react-toastify';

// Action Types
export const FETCH_INVITATION_DETAILS_REQUEST = 'FETCH_INVITATION_DETAILS_REQUEST';
export const FETCH_INVITATION_DETAILS_SUCCESS = 'FETCH_INVITATION_DETAILS_SUCCESS';
export const FETCH_INVITATION_DETAILS_FAILURE = 'FETCH_INVITATION_DETAILS_FAILURE';
export const CLEAR_INVITATION_DETAILS = 'CLEAR_INVITATION_DETAILS';

// Action Creators
export const fetchInvitationDetailsRequest = () => ({
  type: FETCH_INVITATION_DETAILS_REQUEST
});

export const fetchInvitationDetailsSuccess = (details) => ({
  type: FETCH_INVITATION_DETAILS_SUCCESS,
  payload: details
});

export const fetchInvitationDetailsFailure = (error) => ({
  type: FETCH_INVITATION_DETAILS_FAILURE,
  payload: error
});

export const clearInvitationDetails = () => ({
  type: CLEAR_INVITATION_DETAILS
});

// Async Action Creator (Thunk)
export const fetchInvitationDetails = (invitationId) => {
  return async (dispatch) => {
    dispatch(fetchInvitationDetailsRequest());

    try {
      const response = await fetch(`/api/invitation/details/?invitation_id=${invitationId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch(fetchInvitationDetailsSuccess(data));
      return data;
    } catch (error) {
      console.error('Error fetching invitation details:', error);
      const errorMessage = error.message || 'Failed to fetch invitation details';
      dispatch(fetchInvitationDetailsFailure(errorMessage));
      toast.error(errorMessage);
      throw error;
    }
  };
};
